import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class SupportUserAssignedGrievanceService {
  constructor(public httpClient: HttpClient) { }

  //assign grievance list rest
  async assignedGrievanceList() {
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadGrievanceForSE,{})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


  async loadAssignGrievanceStatus(page: number, size: number,statusId){
    const data={
      // page:page,
      // size:size
      statusId:statusId
    }
    let reqParams = `?page=${page}&size=${size}` ;
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadGrievanceForSEStatusWise+`?page=${page}&size=${size}`,data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }


  loadStatus(){
   
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadStatusForAssignedSearch,{})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }

}
